<div class="guardar-dialog" [ngClass]="{'dark-theme': isDark}"
     cdkDrag cdkDragRootElement=".cdk-overlay-pane" [cdkDragDisabled]="!ventana.flotante"
     [class.ventana-flotante]="ventana.flotante" [class.ventana-minimizada]="ventana.isMinimized">
    <div class="guardar-header ventana-asa" cdkDragHandle>
        <h2 class="guardar-title ventana-titulo">
            {{ (data.condiciones && data.condiciones.length > 1) ? 'Guardar ' + data.condiciones.length + ' condiciones en...' : 'Guardar condición en...' }}
        </h2>
        <button mat-icon-button class="close-button ventana-btn-minimizar" *ngIf="ventana.flotante" (click)="ventana.toggle()"
                [title]="ventana.isMinimized ? 'Restaurar' : 'Minimizar'" [attr.aria-label]="ventana.isMinimized ? 'Restaurar' : 'Minimizar'">
          <mat-icon>{{ ventana.isMinimized ? 'open_in_full' : 'remove' }}</mat-icon>
        </button>
        <button mat-icon-button class="close-button" (click)="cerrarDialogo()">
            <mat-icon>close</mat-icon>
        </button>
    </div>



    <div class="guardar-content">
        <mat-button-toggle-group name="stkcfd" aria-label="Font Style" [(ngModel)]="tipoLista"  (ngModelChange)="cargarListas()"
                        [class.custom-toggle-group-light]="!isDark"
                        [class.custom-toggle-group-dark]="isDark">
                        <mat-button-toggle value="listas">Listas</mat-button-toggle>
                        <mat-button-toggle value="tecnicos">Técnicos</mat-button-toggle>
                        <mat-button-toggle value="ratios">Ratios</mat-button-toggle>
                    </mat-button-toggle-group>
        <mat-spinner *ngIf="isLoading" diameter="40" class="loading-spinner"></mat-spinner>
        
        <div *ngIf="!isLoading" class="destinos-lista">
            <div *ngFor="let destino of destinos" class="destino-item">
                <mat-checkbox [(ngModel)]="destino.seleccionado" [disabled]="destino.bloqueado" 
                             [ngClass]="{'dark-checkbox': isDark}">
                    {{ destino.nombre }}
                </mat-checkbox>
                <mat-icon [ngClass]="{'dark-icon': isDark}">
                    {{ destino.bloqueado ? 'lock' : 'lock_open' }}
                </mat-icon>
            </div>
        </div>
        
        <ng-container *ngIf="!mostrarNuevaLista && !isLoading">
            <button mat-button class="nueva-lista-btn" 
                   [ngClass]="{'dark-button': isDark}"
                   (click)="toggleNuevaLista()">
                <mat-icon>add</mat-icon> Nueva lista
            </button>
        </ng-container>
        
        <div *ngIf="mostrarNuevaLista" class="nueva-lista-container" [ngClass]="{'dark-container': isDark}">
            <mat-form-field appearance="outline" class="nueva-lista-input" [ngClass]="{'dark-field': isDark}">
                <input matInput placeholder="Nombre de la lista" [(ngModel)]="nuevaLista">
            </mat-form-field>
            <button mat-button color="primary" (click)="crearNuevaLista()">Crear</button>
            <button mat-icon-button (click)="toggleNuevaLista()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <div class="guardar-actions">
        <button mat-raised-button color="primary" (click)="guardar()" [disabled]="isSaving">
            <mat-spinner *ngIf="isSaving" diameter="20" class="button-spinner"></mat-spinner>
            <span *ngIf="!isSaving">Guardar</span>
            <span *ngIf="isSaving">Guardando...</span>
        </button>
    </div>
</div>